import { memo } from 'react'
import { css, jsx } from '@emotion/react'
import { useColorMode } from '@chakra-ui/react'
import { useRouter } from 'next/router'
import theme from '../../constants/theme'
import MaxWidth from '../MaxWidth'
import useResponsive from '../../utils/hooks/useResponsive'
import LogoHorizontal from '../LogoHorizontal'
import { Button } from '../chakra/Button'
import Div from '../Div'
import DarkModeToggle from '../DarkModeToggle'
import ImgFallbackProgress from '../ImgFallbackProgress'
import UserProfileImg from '../UserProfileImg'
import { Tooltip } from '../chakra/Tooltip'
import { CloseButton } from '../chakra/CloseButton'
import { useUser } from '../../dataHooks'

const styles = {
  container: colorMode => css`
    background: ${theme.colors.drawer[colorMode]};
    transition: background ${theme.transition.duration.background}, color ${theme.transition.duration.color};
  `,
  darkModeToggle: (darkModeToggleTransform, padding) => css`
    transition: all ${theme.transition.duration.normalSlow};
    transform: ${darkModeToggleTransform};
    margin-right: ${padding};
  `,
  picture: css`
    border-radius: 100%;
  `,
  maxWidth: css`
    padding: 0 !important;
  `,
  closeButton: css`
    &:focus {
      box-shadow: 0 0 0 3px ${theme.colors.primary.base};
      transition: box-shadow ${theme.transition.duration.normalSlow};
    }
  `,
}

function ExtensionHeader({ headerHeight, padding }) {
  const { user, loadingUser } = useUser()
  const router = useRouter()
  const { pathname } = router
  const isNewPage = pathname === '/new'
  const { colorMode } = useColorMode()
  const logoSizeH = useResponsive(4, 4.5)
  const logoSizeW = useResponsive(11, 13)
  const darkModeToggleTransform = useResponsive('scale(.68)', 'scale(.75)')
  const pictureSize = useResponsive('30px', '36px')
  const darkModeToggleMr = useResponsive('5px', '13px')

  return (
    <div css={styles.container(colorMode)}>
      <MaxWidth css={styles.maxWidth}>
        <Div flex spaceBetween centerV height={`${headerHeight}px`} padding={`0 ${padding}`}>
          <Button reset to="/">
            <LogoHorizontal sizeW={logoSizeW} sizeH={logoSizeH} />
          </Button>
          <Div flex centerV>
            <DarkModeToggle css={styles.darkModeToggle(darkModeToggleTransform, darkModeToggleMr)} />
            <Tooltip label="Go to dashboard" placement="bottom" hasArrow defaultIsOpen={!!isNewPage} gutter={20}>
              <Div center>
                <Button reset to="/dashboard">
                  <UserProfileImg
                    imageUrl={user?.image}
                    email={user?.email}
                    width={pictureSize}
                    height={pictureSize}
                    css={styles.picture}
                    loadingUser={loadingUser}
                    fallback={<ImgFallbackProgress size={pictureSize} radius="100%" />}
                  />
                </Button>
              </Div>
            </Tooltip>
            <Div center ml={padding}>
              <CloseButton onClick={() => window.close()} css={styles.closeButton} />
            </Div>
          </Div>
        </Div>
      </MaxWidth>
    </div>
  )
}

export default memo(ExtensionHeader)
